import { configResponsive } from "ahooks";
// https://ahooks.js.org/hooks/use-responsive#config
export default configResponsive;
